import { Link } from 'react-router-dom';

const services = [
  {
    title: 'Fenêtres PVC',
    path: '/reparation-fenetre-pvc-paris-15/',
    desc: 'Poignées, crémones, joints, réglages — toutes marques',
    badge: 'Le plus demandé',
    img: '/images/dfpro-svc-pvc-new.webp',
  },
  {
    title: 'Fenêtres Aluminium',
    path: '/reparation-fenetre-aluminium-paris-15/',
    desc: 'Quincaillerie, galets, paumelles, étanchéité',
    badge: 'Haute qualité',
    img: '/images/dfpro-svc-alu-new.webp',
  },
  {
    title: 'Fenêtres Bois',
    path: '/reparation-fenetre-bois-paris-15/',
    desc: 'Crémones d\'époque, réglage, quincaillerie',
    badge: 'Savoir-faire',
    img: '/images/dfpro-svc-bois-new.webp',
  },
  {
    title: 'Baies Vitrées',
    path: '/reparation-baie-vitree-paris-15/',
    desc: 'Galets, rails, serrures — spécialiste grandes baies',
    badge: 'Urgence dispo',
    img: '/images/dfpro-svc-baie-new.webp',
  },
  {
    title: 'Volets Roulants',
    path: '/reparation-volet-roulant-paris-15/',
    desc: 'Sangles, moteurs, lames, treuils — toutes marques',
    badge: 'Moteur Somfy',
    img: '/images/dfpro-svc-volet-new.webp',
  },
];

export default function ServicesSection() {
  return (
    <section className="py-14 md:py-20 bg-[#e6f7f5]">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-brand-dark font-heading">Nos services</h2>
          <p className="text-sm md:text-base text-brand-text/60 max-w-lg">
            Un interlocuteur unique pour tous vos travaux de menuiserie — PVC, Alu, Bois, Baies Vitrées & Volets Roulants
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {services.map((service) => (
            <Link
              key={service.path}
              to={service.path}
              className="group relative h-60 sm:h-72 md:h-80 rounded-2xl overflow-hidden cursor-pointer shadow-lg"
            >
              <img
                alt={`${service.title} — DF PRO réparation Paris 15`}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
                src={service.img}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-black/10 to-transparent"></div>
              <span className="absolute top-3 right-3 bg-brand-accent/90 backdrop-blur-sm text-white text-[10px] sm:text-xs font-semibold px-2.5 py-1.5 rounded-full whitespace-nowrap">
                {service.badge}
              </span>
              <div className="absolute bottom-0 left-0 right-0 p-3 sm:p-4">
                <h3 className="text-sm sm:text-base md:text-lg font-bold text-white font-heading">{service.title}</h3>
                <p className="text-[10px] sm:text-xs text-white/80 mt-1 leading-tight">{service.desc}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}